"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _CoreProps = require("../utilities/CoreProps");
var _Icon = _interopRequireDefault(require("../elements/Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Message = _ref => {
  let {
    size,
    color,
    type,
    showIcon,
    title,
    text,
    children,
    className,
    renderAs,
    onClose
  } = _ref;
  let messageColor = color || type || 'info';
  if (messageColor === 'error') {
    messageColor = 'danger';
  }
  const classNames = (0, _classnames.default)({
    [`is-${messageColor}`]: messageColor,
    [`is-${size}`]: size
  });
  const typeToIconName = {
    success: 'check_circle_outline',
    info: 'info',
    danger: 'error',
    error: 'error',
    warning: 'warning'
  };
  const handleClose = () => {
    onClose();
  };
  const RenderAs = renderAs;
  return /*#__PURE__*/_react.default.createElement(RenderAs, {
    className: (0, _classnames.default)('message', className, classNames) || undefined
  }, title && /*#__PURE__*/_react.default.createElement("div", {
    className: "message-header"
  }, /*#__PURE__*/_react.default.createElement("p", null, title), onClose && /*#__PURE__*/_react.default.createElement("button", {
    className: "delete",
    "aria-label": "delete",
    type: "button",
    onClick: () => {
      handleClose();
    }
  })), children && !text && /*#__PURE__*/_react.default.createElement("div", {
    className: "message-body is-flex is-align-items-start"
  }, showIcon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    color: color || type,
    name: typeToIconName[type] || 'info',
    mr: 2
  }), children), text && /*#__PURE__*/_react.default.createElement("div", {
    className: "message-body"
  }, showIcon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    color: color || type,
    name: typeToIconName[type] || 'info',
    mr: 2
  }), /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _dompurify.default.sanitize(text)
    }
  })));
};
Message.propTypes = {
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['small', 'normal', 'medium', 'large']), _propTypes.default.string]),
  color: _propTypes.default.oneOfType([_propTypes.default.oneOf(['primary', 'link', 'info', 'success', 'warning', 'danger', 'dark']), _propTypes.default.string]),
  type: _propTypes.default.oneOfType([_propTypes.default.oneOf(['info', 'success', 'warning', 'danger', 'error']), _propTypes.default.string]),
  showIcon: _propTypes.default.string,
  title: _propTypes.default.string,
  text: _propTypes.default.string,
  children: _propTypes.default.string,
  className: _propTypes.default.string,
  renderAs: _propTypes.default.string,
  onClose: _propTypes.default.func
};
Message.defaultProps = {
  renderAs: 'article',
  showIcon: false
};
var _default = exports.default = (0, _CoreProps.withUiProps)(Message);
//# sourceMappingURL=Message.js.map